const Animation = (() => {
  let observer;
  const DOM = {};

  const cacheDOM = () => {
    DOM.elements = document.getElementsByClassName("animation");
  };

  const checkPosition = entries => {
    entries.forEach((entry) => {
      if (entry.isIntersecting > 0) {
        const targetAnime = entry.target;
        targetAnime.className = targetAnime.className.replace("animation", "animation-start");
        observer.unobserve(targetAnime);
      }
    });
  };

  const addEventListener = () => {
    const options = {
      threshold: [0.0]
    };

    observer = new IntersectionObserver(checkPosition, options);
    DOM.elements.forEach(element => {
      observer.observe(element);
    });
  };

  const init = () => {
    cacheDOM();
    addEventListener();
  };

  return {
    init
  };
})();

export default Animation;
